module.exports = __webpack_public_path__ + "img/dr-Marcin-Napiorkowski.eeea8d00.jpg";